import { render } from "./TodoToolbar.vue?vue&type=template&id=57884b5b&scoped=true"
import script from "./TodoToolbar.vue?vue&type=script&lang=js"
export * from "./TodoToolbar.vue?vue&type=script&lang=js"

import "./TodoToolbar.vue?vue&type=style&index=0&id=57884b5b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57884b5b"]])

export default __exports__